import React from "react";
import { LocalizedString } from "../services/general/models";
import { stores } from "../stores";

export function dataURItoFile(dataURI, fileName: string) {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    const byteString = atob(dataURI.split(',')[1]);

    // separate out the mime component
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to an ArrayBuffer
    const ab = new ArrayBuffer(byteString.length);

    // create a view into the buffer
    const ia = new Uint8Array(ab);

    // set the bytes of the buffer to the correct values
    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }

    // write the ArrayBuffer to a blob, and you're done
    return new File([ab], fileName, {type: mimeString});
}


export const changeEventHandlerDecorator = (fn: (value: any) => void) => {
    return (e: React.ChangeEvent<HTMLInputElement>) => {
        e.persist();
        fn(e.target.value);
    };
};

export const changeCheckboxEventHandlerDecorator = (fn: (value: any) => void) => {
    return (e: React.ChangeEvent<HTMLInputElement>) => {
        e.persist();
        e.stopPropagation();
        fn(e.target.checked);
    };
};



export const toFloat = (v: string) => {
    const t = parseFloat(v.replace(/[^\d.-]/g, ''));
    if(!isNaN(t)) return parseFloat(t.toFixed(2));
    return 0;
};

export const toStringFloat = (v: string) => {
    return v.replace(/[^\d.-]/g, '');
};



export const toRubbles = (x: number) => {
    return ((x || 0)/100).toFixed(2);
};


export const toPenny = (x: number) => {
    return parseInt((x*100).toFixed(0));
};


export const localize = (s: LocalizedString) => {
    const locale = stores.generalStore.locale.id;
    if (s === null) {
        return ''
    } else if (s[locale] === undefined){
        return ''
    } else {
        return s[locale]
    }

};


export const toLocalizedString = (s: string) => {
    const locale = stores.generalStore.locale.id;
    return {
        [locale]: s
    }
};


export const toFormattedNumber = (x: number) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};

export const convertDate = (date: Date) => {
    let newDate = new Date(date);
    const pad = (s) => {
        return s < 10 ? "0" + s : s;
    };

    return [
        pad(newDate.getDate()),
        pad(newDate.getMonth() + 1),
        pad(newDate.getFullYear())
    ].join(".");
};
